import yup from 'core/utils/validators';

const { object, boolean } = yup;

export const confirmationConditionsFormSchema = () =>
  object().shape({
    // is_data_processing_consent_given: boolean().isTrue('message_is_data_processing_consent_given_required').required('message_is_data_processing_consent_given_required')
  });
